module.exports = __webpack_public_path__ + "media/images/austrian/confirmation/confirmation-card1x-d524c1920adb05b5d8687a63443d211e.jpg";